unit BaseListNoGrid;

interface

uses
  System.SysUtils,
  System.Classes,
  Math,
  JS,
  Web,
  WEBLib.Graphics,
  WEBLib.Controls,
  WEBLib.Forms,
  WEBLib.Dialogs,
  Data.DB,
  WEBLib.DB,
  Vcl.Controls,
  WEBLib.Lists,
  Vcl.StdCtrls,
  WEBLib.StdCtrls,
  WEBLib.Actions,
  WEBLib.WebCtrls,
  WEBLib.Toast,
  smx.webcore.Types,
  Vcl.Imaging.GIFImg,
  WEBLib.ExtCtrls,
  WebForm.Core,
  EditBaseForm,
  Generics.Collections,
  XData.Web.Connection,
  XData.Web.Dataset,
  XData.Web.JsonDataset,
  WEBLib.DBCtrls,
  WEBLib.Grids;

type
  TCustomDataRow = class
  private
    FId: string;
    FData: TDictionary<string, string>;

  public
    constructor Create(const AId: string);
    destructor Destroy; override;

    property Id: string read FId write FId;
    property Data: TDictionary<string, string> read FData;

  end;

  TCustomDataList = TList<TCustomDataRow>;

  TBaseListNoGridForm = class(TCoreWebForm)
    MainDataSource: TDataSource;
    DataTable: TDBTableControl;
    JSONDataset: TXDataJsonDataset;
    cbPageSize: TComboBox;
    edSearch: TEdit;
    lbPaginationInfo: TLabel;
    lcPaginator: TListControl;
    DataContainer: THTMLDiv;
    AddButton: TButton;
    MessageLabel: TLabel;
    SearchButton: TButton;
    WebElementActionList1: TElementActionList;
    ListWaitMessage: TWaitMessage;
    ListCloseTimer: TTimer;
    procedure AddButtonClick(Sender: TObject);
    procedure cbPageSizeChange(Sender: TObject);
    procedure ListCloseTimerTimer(Sender: TObject);
    procedure SearchButtonClick(Sender: TObject);
    procedure WebElementActionList1Actions0Execute(Sender: TObject; Element: TJSHTMLElementRecord;
      Event: TJSEventParameter);
    procedure WebFormCreate(Sender: TObject);
    procedure WebFormDestroy(Sender: TObject);
    procedure PageNumberClick(Sender: TObject);

  private
    { Private declarations }
    FDataList: TCustomDataList;
    FCurrentPage: Integer;
    FPageSize: Integer;
    FTotalRecords: Integer;
    FSearchText: string;
    FIdField: string;
    FColumns: TList<string>;
    FColumnTitles: TDictionary<string, string>;
    FSortField: string;
    FSortDirection: string; // 'ASC' or 'DESC'
    FServerEndpoint: string;
    FDataConnection: TXDataWebConnection;
    
    procedure CreateTableHeader;
    procedure CreateTableRow(const ARow: TCustomDataRow; const ARowIndex: Integer);
    procedure LoadDataFromServer;
    procedure ApplySearch;
    procedure ApplySorting;
    procedure ClearDataContainer;
    procedure ClearPageNumberButtons;

  protected
    procedure CreateTableBody;
    function RecordViewOption: TViewOption; virtual;
    procedure UnLockControls(const AUnLock: Boolean); virtual;
    function CanClose: Boolean; override;

    [async]
    procedure EditRecord(const ARecordId: string); async; virtual;

    procedure AddRecord(const ARecordId: string); virtual;
    procedure SetEditFormLookUps(AForm: TForm); virtual;
    procedure AddRowActions(const ARecordId: string; AParentElement: TJSHTMLElement); virtual;
    procedure PrepareForm; virtual; abstract;

    [async]
    procedure LoadData; async; virtual; abstract;

    function GetEditFormClass: TFormClass; virtual; abstract;
    procedure SearchData(const Value: string); virtual;
    procedure SetPageSize(const APageSize: Integer);
    procedure SetCurrentPage(const APage: Integer);
    procedure SetTotalRecords(const ATotal: Integer);
    procedure SetIdField(const AFieldName: string);
    procedure AddColumn(const AFieldName, ATitle: string);
    procedure SetSortField(const AFieldName: string; const ADirection: string = 'ASC');
    procedure PopulateDataFromServer(const AData: TJSArray); virtual;
    procedure HandleServerResponse(const AResponse: TJSObject); virtual;
    procedure ShowLoadingState;
    procedure HideLoadingState;
    procedure SetServerEndpoint(const AEndpoint: string);
    procedure SetDataConnection(const AConnection: TXDataWebConnection);
    
    // Virtual methods for descendant forms to override
    procedure ConfigureDatasetFields; virtual;
    procedure ConfigureTableColumns; virtual;
    procedure ConfigureGrid; virtual;
    procedure GenerateFieldDefs; virtual; abstract;

  public
    { Public declarations }
    procedure SetupTableStructure;
    procedure UpdatePagination;
    procedure RefreshData;
    
    // Helper methods for field definition
    procedure AddFieldDef(const AFieldName: string; AFieldType: TFieldType; ASize: Integer = 0);
    procedure AddColumnDef(const AFieldName, ATitle: string; AWidth: Integer = 100);

    property IdField: string read FIdField write SetIdField;
    property CurrentPage: Integer read FCurrentPage write SetCurrentPage;
    property PageSize: Integer read FPageSize write SetPageSize;
    property TotalRecords: Integer read FTotalRecords write SetTotalRecords;
    property SearchText: string read FSearchText;
    property DataList: TCustomDataList read FDataList;
    property ServerEndpoint: string read FServerEndpoint write SetServerEndpoint;
    property DataConnection: TXDataWebConnection read FDataConnection write SetDataConnection;

  protected procedure LoadDFMValues; override; end;

implementation

uses
  MainDataModule,
  smx.Web.Layout.Utils;

{$R *.dfm}

procedure TBaseListNoGridForm.WebFormCreate(Sender: TObject);
begin
  inherited;

  // initialize
  FDataList := TCustomDataList.Create;
  FColumns := TList<string>.Create;
  FColumnTitles := TDictionary<string, string>.Create;
  FCurrentPage := 1;
  FPageSize := 10;
  FTotalRecords := 0;
  FSearchText := '';
  FIdField := 'Id';
  FSortField := '';
  FSortDirection := 'ASC';
  FServerEndpoint := '';
  FDataConnection := nil;

  // configure controls
  MessageLabel.Caption := '';
  AddButton.Enabled := (RecordViewOption = voCreateAndEdit);
  AddButton.Visible := AddButton.Enabled;

  // prepare the form
  PrepareForm;

  // configure grid (fields and columns)
  ConfigureGrid;

  // unlock
  UnLockControls(False);

end;

procedure TBaseListNoGridForm.WebFormDestroy(Sender: TObject);
var
  iIdx: Integer;

begin
  // clear data list
  if Assigned(FDataList) then
  begin
    for iIdx := 0 to FDataList.Count - 1 do
      FDataList[iIdx].Destroy;

    FDataList.Free;
    FDataList := nil;

  end;

  // clear columns
  if Assigned(FColumns) then
  begin
    FColumns.Free;
    FColumns := nil;

  end;

  // clear column titles
  if Assigned(FColumnTitles) then
  begin
    FColumnTitles.Free;
    FColumnTitles := nil;

  end;

  inherited;

end;

procedure TBaseListNoGridForm.AddButtonClick(Sender: TObject);
begin
  AddRecord('');

end;

procedure TBaseListNoGridForm.AddRecord(const ARecordId: string);
begin
  EditRecord(ARecordId);

end;

procedure TBaseListNoGridForm.AddRowActions(const ARecordId: string; AParentElement: TJSHTMLElement);

  procedure EditClick(Sender: TObject);
  begin
    EditRecord(ARecordId);

  end;

var
  Span: THTMLSpan;

begin
  if (RecordViewOption in [voEdit, voCreateAndEdit]) then
  begin
    Span := TLayoutUtils.RowActionSpan(AParentElement, 'fad fa-edit', 'Edit');
    Span.OnClick := @EditClick;

  end
  else if RecordViewOption = voReadOnly then
  begin
    Span := TLayoutUtils.RowActionSpan(AParentElement, 'fad fa-eye', 'View');
    Span.OnClick := @EditClick;

  end;

end;

function TBaseListNoGridForm.CanClose: Boolean;
begin
  Result := True;

end;

procedure TBaseListNoGridForm.cbPageSizeChange(Sender: TObject);
begin
  SetPageSize(StrToInt(cbPageSize.Text));
  RefreshData;

end;

procedure TBaseListNoGridForm.ListCloseTimerTimer(Sender: TObject);
begin
  ListCloseTimer.Enabled := False;
  ListWaitMessage.Hide;

end;

procedure TBaseListNoGridForm.SearchButtonClick(Sender: TObject);
begin
  SearchData(edSearch.Text);

end;

procedure TBaseListNoGridForm.SearchData(const Value: string);
begin
  FSearchText := Value;
  FCurrentPage := 1;
  RefreshData;

end;

procedure TBaseListNoGridForm.WebElementActionList1Actions0Execute(Sender: TObject; Element: TJSHTMLElementRecord;
  Event: TJSEventParameter);
begin
  if TJSKeyboardEvent(Event.JSEvent).Key = 'Enter' then
  begin
    Event.JSEvent.preventDefault;
    SearchData(edSearch.Text);

  end;

end;

function TBaseListNoGridForm.RecordViewOption: TViewOption;
begin
  Result := voCreateAndEdit;

end;

procedure TBaseListNoGridForm.UnLockControls(const AUnLock: Boolean);
begin
  AddButton.Enabled := (RecordViewOption = voCreateAndEdit) and AUnLock;
  SearchButton.Enabled := AUnLock;
  cbPageSize.Enabled := AUnLock;
  edSearch.Enabled := AUnLock;

end;

procedure TBaseListNoGridForm.EditRecord(const ARecordId: string);
var
  AForm: TBaseEditForm;

begin
  AForm := TBaseEditForm(GetEditFormClass.Create(Self));
  try
    AForm.Popup := True;
    AForm.PopupOpacity := 1;
    await(TBaseEditForm, AForm.Load());
    AForm.IdField := FIdField;
    SetEditFormLookUps(AForm);
    AForm.RecordViewOption := Self.RecordViewOption;

    // Handle record editing - this would need to be customized based on your data structure
    // For now, we'll just show the form
    await(TModalResult, AForm.Execute);

  finally
    AForm.Free;
    AForm := nil;

  end;

end;

procedure TBaseListNoGridForm.SetEditFormLookUps(AForm: TForm);
begin
  // For descendants

end;

procedure TBaseListNoGridForm.SetPageSize(const APageSize: Integer);
begin
  FPageSize := APageSize;

end;

procedure TBaseListNoGridForm.SetCurrentPage(const APage: Integer);
begin
  FCurrentPage := APage;

end;

procedure TBaseListNoGridForm.SetTotalRecords(const ATotal: Integer);
begin
  FTotalRecords := ATotal;

end;

procedure TBaseListNoGridForm.SetIdField(const AFieldName: string);
begin
  FIdField := AFieldName;

end;

procedure TBaseListNoGridForm.AddColumn(const AFieldName, ATitle: string);
begin
  if Assigned(FColumns) then
    FColumns.Add(AFieldName);

  if Assigned(FColumnTitles) then
    FColumnTitles.Add(AFieldName, ATitle);

end;

procedure TBaseListNoGridForm.SetSortField(const AFieldName: string; const ADirection: string);
begin
  FSortField := AFieldName;
  FSortDirection := ADirection;

end;

procedure TBaseListNoGridForm.PopulateDataFromServer(const AData: TJSArray);
var
  iIdx: Integer;
  oDataRow: TCustomDataRow;
  oItem: TJSObject;
  sKey, sValue: string;

begin
  if not Assigned(FDataList) then
    Exit;
    
  FDataList.Clear;
  
  for iIdx := 0 to AData.Length - 1 do
  begin
    oItem := TJSObject(AData[iIdx]);
    oDataRow := TCustomDataRow.Create(JS.toString(oItem[FIdField]));
    
    // Populate all fields from the server response
    if Assigned(FColumnTitles) then
    begin
      for sKey in FColumnTitles.Keys do
      begin
        if oItem[sKey] <> nil then
          sValue := JS.toString(oItem[sKey])
        else
          sValue := '';

        oDataRow.Data.Add(sKey, sValue);

      end;

    end;
    
    FDataList.Add(oDataRow);

  end;

end;

procedure TBaseListNoGridForm.HandleServerResponse(const AResponse: TJSObject);
var
  aData: TJSArray;
  nTotal: Integer;

begin
  if AResponse['data'] <> nil then
  begin
    aData := TJSArray(AResponse['data']);
    PopulateDataFromServer(aData);

  end;
  
  if AResponse['total'] <> nil then
  begin
    nTotal := JS.toInteger(AResponse['total']);
    SetTotalRecords(nTotal);

  end;
  
  CreateTableBody;
  UpdatePagination;
//  HideLoadingState;

end;

procedure TBaseListNoGridForm.ShowLoadingState;
begin
  ListWaitMessage.Show;
  ListCloseTimer.Enabled := False;

end;

procedure TBaseListNoGridForm.HideLoadingState;
begin
  ListWaitMessage.Hide;
  ListCloseTimer.Enabled := True;

end;

procedure TBaseListNoGridForm.LoadDataFromServer;
begin
//  ShowLoadingState;

  if FDataConnection <> nil then
  begin
    try
      // Call the abstract LoadData method which descendants can override
      // to implement their own server communication logic
      LoadData;

    except
      on E: Exception do
      begin
//        HideLoadingState;
        DisplayMessage('Error loading data: ' + E.Message, mtError);

      end;

    end;

  end
  else
  begin
    // Fall back to abstract LoadData method
    LoadData;

  end;

end;

procedure TBaseListNoGridForm.ApplySearch;
begin
  // Override in descendants to implement search logic

end;

procedure TBaseListNoGridForm.ApplySorting;
begin
  // Override in descendants to implement sorting logic

end;

procedure TBaseListNoGridForm.ClearDataContainer;
begin
  DataContainer.Element.innerHTML := '';

end;

procedure TBaseListNoGridForm.SetupTableStructure;
begin
  ClearDataContainer;
  CreateTableHeader;

end;

procedure TBaseListNoGridForm.CreateTableHeader;
var
  oTable, oHeaderRow, oHeaderCell: TJSHTMLElement;
  iIdx: Integer;
  sColumnName, sTitle: string;

begin
  oTable := TJSHTMLElement(document.createElement('table'));
  oTable.className := 'table table-striped table-bordered table-hover';
  
  oHeaderRow := TJSHTMLElement(document.createElement('tr'));
  oHeaderRow.className := 'table-header';
  
  // Add header cells for each column
  if Assigned(FColumns) then
  begin
    for iIdx := 0 to FColumns.Count - 1 do
    begin
      sColumnName := FColumns[iIdx];
      if Assigned(FColumnTitles) and FColumnTitles.TryGetValue(sColumnName, sTitle) then
      begin
        oHeaderCell := TJSHTMLElement(document.createElement('th'));
        oHeaderCell.innerHTML := sTitle;
        oHeaderCell.className := 'sortable-header';
        oHeaderCell.setAttribute('data-field', sColumnName);
        oHeaderRow.appendChild(oHeaderCell);

      end;

    end;

  end;
  
  // Add Actions column if needed
  if RecordViewOption in [voEdit, voCreateAndEdit, voReadOnly] then
  begin
    oHeaderCell := TJSHTMLElement(document.createElement('th'));
    oHeaderCell.innerHTML := 'Actions';
    oHeaderCell.className := 'actions-header';
    oHeaderRow.appendChild(oHeaderCell);

  end;
  
  oTable.appendChild(oHeaderRow);
  DataContainer.Element.appendChild(oTable);

end;

procedure TBaseListNoGridForm.CreateTableBody;
var
  oTable, oBody: TJSHTMLElement;
  iIdx: Integer;

begin
  // Find the existing table and add tbody
  oTable := TJSHTMLElement(DataContainer.Element.querySelector('table'));
  if oTable <> nil then
  begin
    // Remove existing tbody if it exists
    if oTable.querySelector('tbody') <> nil then
      oTable.removeChild(oTable.querySelector('tbody'));
    
    // Create new tbody
    oBody := TJSHTMLElement(document.createElement('tbody'));
    
    if Assigned(FDataList) then
    begin
      for iIdx := 0 to FDataList.Count - 1 do
        CreateTableRow(FDataList[iIdx], iIdx);

    end;
    
    oTable.appendChild(oBody);

  end;

end;

procedure TBaseListNoGridForm.CreateTableRow(const ARow: TCustomDataRow; const ARowIndex: Integer);
var
  oTable, oRow, oCell, oActionsCell, oTableBody: TJSHTMLElement;
  iIdx: Integer;
  sColumnName, sValue: string;

begin
  oTable := TJSHTMLElement(DataContainer.Element.querySelector('table'));
  if oTable = nil then
    Exit;

  oTableBody := TJSHTMLElement(oTable.querySelector('tbody'));
  if oTableBody = nil then
    Exit;
  
  oRow := TJSHTMLElement(document.createElement('tr'));
  oRow.className := 'data-row';
  oRow.setAttribute('data-id', ARow.Id);
  
  // Add data cells
  if Assigned(FColumns) then
  begin
    for iIdx := 0 to FColumns.Count - 1 do
    begin
      sColumnName := FColumns[iIdx];
      if ARow.Data.TryGetValue(sColumnName, sValue) then
      begin
        oCell := TJSHTMLElement(document.createElement('td'));
        oCell.innerHTML := sValue;
        oCell.className := 'data-cell';
        oRow.appendChild(oCell);

      end;

    end;

  end;
  
  // Add Actions cell if needed
  if RecordViewOption in [voEdit, voCreateAndEdit, voReadOnly] then
  begin
    oActionsCell := TJSHTMLElement(document.createElement('td'));
    oActionsCell.className := 'actions-cell';
    AddRowActions(ARow.Id, oActionsCell);
    oRow.appendChild(oActionsCell);

  end;
  
  oTableBody.appendChild(oRow);

end;

procedure TBaseListNoGridForm.UpdatePagination;
var
  iPageCount, iFirstRecord, iLastRecord, iStartPage, iEndPage, iIdx: Integer;
  oPaginationDiv, oUl, oLi, oLink: TJSHTMLElement;
  sLiClass, sLinkClass: string;
  bShowFirstEllipsis, bShowLastEllipsis: Boolean;

begin
  if FTotalRecords = 0 then
  begin
    lbPaginationInfo.Caption := 'No records to display';
    // Clear existing pagination
    ClearPageNumberButtons;
    Exit;

  end;
  
  iPageCount := (FTotalRecords + FPageSize - 1) div FPageSize;
  iFirstRecord := ((FCurrentPage - 1) * FPageSize) + 1;
  iLastRecord := Min(FCurrentPage * FPageSize, FTotalRecords);
  
  lbPaginationInfo.Caption := Format(
    'Showing %s to %s of %s entries',
    [FormatFloat('#,##0', iFirstRecord), FormatFloat('#,##0', iLastRecord), FormatFloat('#,##0', FTotalRecords)]
  );
  
  // Clear existing pagination
  ClearPageNumberButtons;
  
  // Get the pagination div element (lcPaginator.Element)
  oPaginationDiv := TJSHTMLElement(lcPaginator.Element);
  if oPaginationDiv = nil then
    Exit;
  
  // Clear the div content
  oPaginationDiv.innerHTML := '';
  
  // Create the ul element with pagination class
  oUl := TJSHTMLElement(document.createElement('ul'));
  oUl.className := 'pagination';
  
  // Calculate which page numbers to show (max 8 pages with ellipsis)
  if iPageCount <= 8 then
  begin
    // Show all pages if 8 or fewer
    iStartPage := 1;
    iEndPage := iPageCount;
    bShowFirstEllipsis := False;
    bShowLastEllipsis := False;

  end
  else
  begin
    // Determine if we need ellipsis
    bShowFirstEllipsis := (FCurrentPage > 5);
    bShowLastEllipsis := (FCurrentPage < iPageCount - 4);
    
    if bShowFirstEllipsis and bShowLastEllipsis then
    begin
      // Show: [1] [...] [curr-1] [curr] [curr+1] [curr+2] [...] [last]
      iStartPage := FCurrentPage - 1;
      iEndPage := FCurrentPage + 2;

    end
    else if bShowFirstEllipsis then
    begin
      // Show: [1] [...] [last-5] [last-4] [last-3] [last-2] [last-1] [last]
      iStartPage := iPageCount - 5;
      iEndPage := iPageCount;

    end
    else if bShowLastEllipsis then
    begin
      // Show: [1] [2] [3] [4] [5] [6] [...] [last]
      iStartPage := 1;
      iEndPage := 6;

    end
    else
    begin
      // This shouldn't happen with the logic above, but fallback
      iStartPage := 1;
      iEndPage := iPageCount;

    end;

  end;
  
  // Create pagination items
  try
    // First, add page 1 if we need first ellipsis
    if bShowFirstEllipsis then
    begin
      // Create li for page 1
      oLi := TJSHTMLElement(document.createElement('li'));
      if 1 = FCurrentPage then
        sLiClass := 'pagination_button active'
      else
        sLiClass := 'pagination_button';
      oLi.className := sLiClass;
      
      // Create link for page 1
      oLink := TJSHTMLElement(document.createElement('a'));
      if 1 = FCurrentPage then
        sLinkClass := 'page-link active'
      else
        sLinkClass := 'page-link';
      oLink.className := sLinkClass;
      oLink.setAttribute('href', '#');
      oLink.innerHTML := '1';
      oLink.setAttribute('data-page', '1');
      
      // Add click handler using onclick
      oLink.onclick := function(e: TJSMouseEvent): Boolean
      var
        oTarget: TJSHTMLElement;
        nPageNum: Integer;
      begin
        e.preventDefault;
        oTarget := TJSHTMLElement(e.target);
        nPageNum := StrToIntDef(string(oTarget.getAttribute('data-page')), 1);
        FCurrentPage := nPageNum;
        if Assigned(JSONDataset) and JSONDataset.Active then
          JSONDataset.Close;
        LoadData;
        Result := False; // Prevent default navigation
      end;
      
      oLi.appendChild(oLink);
      oUl.appendChild(oLi);
      
      // Add ellipsis after page 1
      oLi := TJSHTMLElement(document.createElement('li'));
      oLi.className := 'pagination_button disabled';
      oLink := TJSHTMLElement(document.createElement('a'));
      oLink.className := 'page-link';
      oLink.setAttribute('href', '#');
      oLink.innerHTML := '...';
      oLi.appendChild(oLink);
      oUl.appendChild(oLi);

    end;
    
    // Add the main range of pages
    for iIdx := iStartPage to iEndPage do
    begin
      // Skip page 1 if we already added it (when bShowFirstEllipsis is true)
      if bShowFirstEllipsis and (iIdx = 1) then
        Continue;
      
      // Skip last page if we're going to add it separately (when bShowLastEllipsis is true)
      if bShowLastEllipsis and (iIdx = iPageCount) then
        Continue;
      
      // Create li for page number
      oLi := TJSHTMLElement(document.createElement('li'));
      if iIdx = FCurrentPage then
        sLiClass := 'pagination_button active'
      else
        sLiClass := 'pagination_button';
      oLi.className := sLiClass;
      
      // Create link for page number
      oLink := TJSHTMLElement(document.createElement('a'));
      if iIdx = FCurrentPage then
        sLinkClass := 'page-link active'
      else
        sLinkClass := 'page-link';
      oLink.className := sLinkClass;
      oLink.setAttribute('href', '#');
      oLink.innerHTML := IntToStr(iIdx);
      oLink.setAttribute('data-page', IntToStr(iIdx));
      
      // Add click handler - use e.target to get the clicked element
      oLink.onclick := function(e: TJSMouseEvent): Boolean
      var
        oTarget: TJSHTMLElement;
        nPageNum: Integer;
      begin
        e.preventDefault;
        oTarget := TJSHTMLElement(e.target);
        nPageNum := StrToIntDef(string(oTarget.getAttribute('data-page')), iIdx);
        FCurrentPage := nPageNum;
        if Assigned(JSONDataset) and JSONDataset.Active then
          JSONDataset.Close;
        LoadData;
        Result := False; // Prevent default navigation
      end;
      
      oLi.appendChild(oLink);
      oUl.appendChild(oLi);

    end;
    
    // Add last page and ellipsis if needed
    if bShowLastEllipsis then
    begin
      // Add ellipsis before last page
      oLi := TJSHTMLElement(document.createElement('li'));
      oLi.className := 'pagination_button disabled';
      oLink := TJSHTMLElement(document.createElement('a'));
      oLink.className := 'page-link';
      oLink.setAttribute('href', '#');
      oLink.innerHTML := '...';
      oLi.appendChild(oLink);
      oUl.appendChild(oLi);
      
      // Add last page
      oLi := TJSHTMLElement(document.createElement('li'));
      if iPageCount = FCurrentPage then
        sLiClass := 'pagination_button active'
      else
        sLiClass := 'pagination_button';
      oLi.className := sLiClass;
      
      oLink := TJSHTMLElement(document.createElement('a'));
      if iPageCount = FCurrentPage then
        sLinkClass := 'page-link active'
      else
        sLinkClass := 'page-link';
      oLink.className := sLinkClass;
      oLink.setAttribute('href', '#');
      oLink.innerHTML := IntToStr(iPageCount);
      oLink.setAttribute('data-page', IntToStr(iPageCount));
      
      // Add click handler
      oLink.onclick := function(e: TJSMouseEvent): Boolean
      var
        oTarget: TJSHTMLElement;
        nPageNum: Integer;
      begin
        e.preventDefault;
        oTarget := TJSHTMLElement(e.target);
        nPageNum := StrToIntDef(string(oTarget.getAttribute('data-page')), iPageCount);
        FCurrentPage := nPageNum;
        if Assigned(JSONDataset) and JSONDataset.Active then
          JSONDataset.Close;
        LoadData;
        Result := False; // Prevent default navigation

      end;
      
      oLi.appendChild(oLink);
      oUl.appendChild(oLi);

    end;
    
    // Append the ul to the pagination div
    oPaginationDiv.appendChild(oUl);

  except
    on E: Exception do
    begin
      // If pagination fails, show error message
      oPaginationDiv.innerHTML := '<span class="text-danger">Pagination Error: ' + E.Message + '</span>';

    end;

  end;

end;

procedure TBaseListNoGridForm.RefreshData;
begin
  // Close the dataset before refreshing
  if Assigned(JSONDataset) and JSONDataset.Active then
    JSONDataset.Close;
    
  LoadData;

end;

procedure TBaseListNoGridForm.SetServerEndpoint(const AEndpoint: string);
begin
  FServerEndpoint := AEndpoint;

end;

procedure TBaseListNoGridForm.SetDataConnection(const AConnection: TXDataWebConnection);
begin
  FDataConnection := AConnection;

end;

{ TCustomDataRow }

constructor TCustomDataRow.Create(const AId: string);
begin
  inherited Create;
  FId := AId;
  FData := TDictionary<string, string>.Create;

end;

destructor TCustomDataRow.Destroy;
begin
  FData.Free;
  inherited Destroy;

end;


procedure TBaseListNoGridForm.PageNumberClick(Sender: TObject);
var
  iPageNumber: Integer;

begin
  if Sender is TButton then
  begin
    iPageNumber := TButton(Sender).Tag;
    if (iPageNumber > 0) and (iPageNumber <> FCurrentPage) then
    begin
      FCurrentPage := iPageNumber;
      // Close dataset before loading new data
      if Assigned(JSONDataset) and JSONDataset.Active then
        JSONDataset.Close;

      LoadData;

    end;

  end;

end;

procedure TBaseListNoGridForm.ClearPageNumberButtons;
var
  iIdx: Integer;
  oControl: TControl;

begin
  // Clear all controls from the paginator
  for iIdx := lcPaginator.ControlCount - 1 downto 0 do
  begin
    oControl := lcPaginator.Controls[iIdx];
    oControl.Free;

  end;

end;

procedure TBaseListNoGridForm.ConfigureDatasetFields;
begin
  // Default implementation - descendants can override to define their own fields
  // This method is called after PrepareForm but before data loading

end;

procedure TBaseListNoGridForm.ConfigureTableColumns;
begin
  // Default implementation - descendants can override to define their own columns
  // This method is called after ConfigureDatasetFields

end;

procedure TBaseListNoGridForm.ConfigureGrid;
begin
  // Clear existing field definitions and columns
  JSONDataset.FieldDefs.Clear;
  DataTable.Columns.Clear;
  
  // Call the virtual method for descendants to define their fields
  GenerateFieldDefs;

end;

procedure TBaseListNoGridForm.AddFieldDef(const AFieldName: string; AFieldType: TFieldType; ASize: Integer = 0);
begin
  if ASize > 0 then
    JSONDataset.FieldDefs.Add(AFieldName, AFieldType, ASize)
  else
    JSONDataset.FieldDefs.Add(AFieldName, AFieldType);

end;

procedure TBaseListNoGridForm.AddColumnDef(const AFieldName, ATitle: string; AWidth: Integer = 100);
begin
  with DataTable.Columns.Add do
  begin
    DataField := AFieldName;
    Title := ATitle;
    Width := AWidth;

  end;

end;

procedure TBaseListNoGridForm.LoadDFMValues;
begin
  inherited LoadDFMValues;

  lbPaginationInfo := TLabel.Create('PageInfo');
  MessageLabel := TLabel.Create('MessageLabel');
  cbPageSize := TComboBox.Create('PageSizeSelect');
  edSearch := TEdit.Create('SearchText');
  lcPaginator := TListControl.Create('Pagination');
  DataContainer := THTMLDiv.Create('DataContainer');
  AddButton := TButton.Create('AddButton');
  SearchButton := TButton.Create('SearchButton');
  ListWaitMessage := TWaitMessage.Create(Self);
  DataTable := TDBTableControl.Create('DataTable');
  MainDataSource := TDataSource.Create(Self);
  JSONDataset := TXDataJsonDataset.Create(Self);
  WebElementActionList1 := TElementActionList.Create(Self);
  ListCloseTimer := TTimer.Create(Self);

  lbPaginationInfo.BeforeLoadDFMValues;
  MessageLabel.BeforeLoadDFMValues;
  cbPageSize.BeforeLoadDFMValues;
  edSearch.BeforeLoadDFMValues;
  lcPaginator.BeforeLoadDFMValues;
  DataContainer.BeforeLoadDFMValues;
  AddButton.BeforeLoadDFMValues;
  SearchButton.BeforeLoadDFMValues;
  ListWaitMessage.BeforeLoadDFMValues;
  DataTable.BeforeLoadDFMValues;
  MainDataSource.BeforeLoadDFMValues;
  JSONDataset.BeforeLoadDFMValues;
  WebElementActionList1.BeforeLoadDFMValues;
  ListCloseTimer.BeforeLoadDFMValues;
  try
    Name := 'BaseListNoGridForm';
    SetEvent(Self, 'OnCreate', 'WebFormCreate');
    SetEvent(Self, 'OnDestroy', 'WebFormDestroy');
    lbPaginationInfo.SetParentComponent(Self);
    lbPaginationInfo.Name := 'lbPaginationInfo';
    lbPaginationInfo.Left := 8;
    lbPaginationInfo.Top := 376;
    lbPaginationInfo.Width := 112;
    lbPaginationInfo.Height := 15;
    lbPaginationInfo.Caption := 'No records to display';
    lbPaginationInfo.ElementFont := efCSS;
    lbPaginationInfo.ElementPosition := epIgnore;
    lbPaginationInfo.HeightStyle := ssAuto;
    lbPaginationInfo.HeightPercent := 100.000000000000000000;
    lbPaginationInfo.WidthStyle := ssAuto;
    lbPaginationInfo.WidthPercent := 100.000000000000000000;
    MessageLabel.SetParentComponent(Self);
    MessageLabel.Name := 'MessageLabel';
    MessageLabel.Left := 232;
    MessageLabel.Top := 24;
    MessageLabel.Width := 74;
    MessageLabel.Height := 15;
    MessageLabel.Caption := 'MessageLabel';
    MessageLabel.ElementFont := efCSS;
    MessageLabel.ElementPosition := epIgnore;
    MessageLabel.HeightStyle := ssAuto;
    MessageLabel.HeightPercent := 100.000000000000000000;
    MessageLabel.HTMLType := tDIV;
    MessageLabel.WidthStyle := ssAuto;
    MessageLabel.WidthPercent := 100.000000000000000000;
    cbPageSize.SetParentComponent(Self);
    cbPageSize.Name := 'cbPageSize';
    cbPageSize.Left := 8;
    cbPageSize.Top := 67;
    cbPageSize.Width := 81;
    cbPageSize.Height := 23;
    cbPageSize.ElementClassName := 'form-select';
    cbPageSize.ElementFont := efCSS;
    cbPageSize.ElementPosition := epIgnore;
    cbPageSize.HeightStyle := ssAuto;
    cbPageSize.HeightPercent := 100.000000000000000000;
    cbPageSize.Text := '10';
    cbPageSize.WidthStyle := ssAuto;
    cbPageSize.WidthPercent := 100.000000000000000000;
    SetEvent(cbPageSize, Self, 'OnChange', 'cbPageSizeChange');
    cbPageSize.ItemIndex := 0;
    cbPageSize.Items.BeginUpdate;
    try
      cbPageSize.Items.Clear;
      cbPageSize.Items.Add('10');
      cbPageSize.Items.Add('25');
      cbPageSize.Items.Add('50');
      cbPageSize.Items.Add('100');
    finally
      cbPageSize.Items.EndUpdate;
    end;
    edSearch.SetParentComponent(Self);
    edSearch.Name := 'edSearch';
    edSearch.Left := 408;
    edSearch.Top := 67;
    edSearch.Width := 121;
    edSearch.Height := 21;
    edSearch.ChildOrder := 1;
    edSearch.ElementClassName := 'form-control';
    edSearch.ElementFont := efCSS;
    edSearch.ElementPosition := epIgnore;
    edSearch.HeightStyle := ssAuto;
    edSearch.HeightPercent := 100.000000000000000000;
    edSearch.WidthStyle := ssAuto;
    edSearch.WidthPercent := 100.000000000000000000;
    lcPaginator.SetParentComponent(Self);
    lcPaginator.Name := 'lcPaginator';
    lcPaginator.Left := 240;
    lcPaginator.Top := 365;
    lcPaginator.Width := 289;
    lcPaginator.Height := 25;
    lcPaginator.HeightStyle := ssAuto;
    lcPaginator.WidthStyle := ssAuto;
    lcPaginator.HeightPercent := 100.000000000000000000;
    lcPaginator.WidthPercent := 100.000000000000000000;
    lcPaginator.ChildOrder := 3;
    lcPaginator.DefaultItemClassName := 'page-item';
    lcPaginator.DefaultItemLinkClassName := 'page-link';
    lcPaginator.ElementFont := efCSS;
    lcPaginator.ElementPosition := epIgnore;
    lcPaginator.ElementListClassName := 'pagination';
    lcPaginator.Style := lsPagination;
    DataContainer.SetParentComponent(Self);
    DataContainer.Name := 'DataContainer';
    DataContainer.Left := 32;
    DataContainer.Top := 104;
    DataContainer.Width := 513;
    DataContainer.Height := 249;
    DataContainer.HeightStyle := ssAuto;
    DataContainer.WidthStyle := ssAuto;
    DataContainer.ChildOrder := 4;
    DataContainer.ElementPosition := epIgnore;
    DataContainer.ElementFont := efCSS;
    DataContainer.Role := '';
    AddButton.SetParentComponent(Self);
    AddButton.Name := 'AddButton';
    AddButton.Left := 408;
    AddButton.Top := 408;
    AddButton.Width := 96;
    AddButton.Height := 25;
    AddButton.Caption := 'Add';
    AddButton.ChildOrder := 5;
    AddButton.ElementClassName := 'btn btn-primary';
    AddButton.ElementFont := efCSS;
    AddButton.ElementPosition := epIgnore;
    AddButton.HeightStyle := ssAuto;
    AddButton.HeightPercent := 100.000000000000000000;
    AddButton.WidthStyle := ssAuto;
    AddButton.WidthPercent := 100.000000000000000000;
    SetEvent(AddButton, Self, 'OnClick', 'AddButtonClick');
    SearchButton.SetParentComponent(Self);
    SearchButton.Name := 'SearchButton';
    SearchButton.Left := 535;
    SearchButton.Top := 65;
    SearchButton.Width := 33;
    SearchButton.Height := 25;
    SearchButton.Caption := 'Find';
    SearchButton.ChildOrder := 7;
    SearchButton.ElementClassName := 'btn btn-primary input-group-append';
    SearchButton.ElementFont := efCSS;
    SearchButton.ElementPosition := epIgnore;
    SearchButton.HeightStyle := ssAuto;
    SearchButton.HeightPercent := 100.000000000000000000;
    SearchButton.WidthStyle := ssAuto;
    SearchButton.WidthPercent := 100.000000000000000000;
    SetEvent(SearchButton, Self, 'OnClick', 'SearchButtonClick');
    ListWaitMessage.SetParentComponent(Self);
    ListWaitMessage.Name := 'ListWaitMessage';
    ListWaitMessage.Left := 392;
    ListWaitMessage.Top := 24;
    ListWaitMessage.Width := 24;
    ListWaitMessage.Height := 24;
    ListWaitMessage.HeightStyle := ssAuto;
    ListWaitMessage.WidthStyle := ssAuto;
    ListWaitMessage.Opacity := 0.200000000000000000;
    ListWaitMessage.PictureURL := 'images/Whirligig.gif';
    DataTable.SetParentComponent(Self);
    DataTable.Name := 'DataTable';
    DataTable.Left := 32;
    DataTable.Top := 104;
    DataTable.Width := 513;
    DataTable.Height := 249;
    DataTable.HeightStyle := ssAuto;
    DataTable.WidthStyle := ssAuto;
    DataTable.BorderColor := clSilver;
    DataTable.ElementFont := efCSS;
    DataTable.ElementPosition := epIgnore;
    MainDataSource.SetParentComponent(Self);
    MainDataSource.Name := 'MainDataSource';
    MainDataSource.Left := 144;
    MainDataSource.Top := 8;
    JSONDataset.SetParentComponent(Self);
    JSONDataset.Name := 'JSONDataset';
    JSONDataset.Left := 232;
    JSONDataset.Top := 8;
    WebElementActionList1.SetParentComponent(Self);
    WebElementActionList1.Name := 'WebElementActionList1';
    WebElementActionList1.Actions.Clear;
    with WebElementActionList1.Actions.Add do
    begin
      Control := edSearch;
      Event := heKeypress;
      ID := 'SearchText';
      Name := 'TrapEnter';
      PreventDefault := False;
      SetEvent(Self, 'OnExecute', 'WebElementActionList1Actions0Execute');
    end;
    WebElementActionList1.Left := 312;
    WebElementActionList1.Top := 48;
    ListCloseTimer.SetParentComponent(Self);
    ListCloseTimer.Name := 'ListCloseTimer';
    ListCloseTimer.Enabled := False;
    SetEvent(ListCloseTimer, Self, 'OnTimer', 'ListCloseTimerTimer');
    ListCloseTimer.Left := 432;
    ListCloseTimer.Top := 16;
  finally
    lbPaginationInfo.AfterLoadDFMValues;
    MessageLabel.AfterLoadDFMValues;
    cbPageSize.AfterLoadDFMValues;
    edSearch.AfterLoadDFMValues;
    lcPaginator.AfterLoadDFMValues;
    DataContainer.AfterLoadDFMValues;
    AddButton.AfterLoadDFMValues;
    SearchButton.AfterLoadDFMValues;
    ListWaitMessage.AfterLoadDFMValues;
    DataTable.AfterLoadDFMValues;
    MainDataSource.AfterLoadDFMValues;
    JSONDataset.AfterLoadDFMValues;
    WebElementActionList1.AfterLoadDFMValues;
    ListCloseTimer.AfterLoadDFMValues;
  end;
end;

end.

Exc